import { verifyPasswordResetCode } from 'firebase/auth';

import { getAuthentication } from './helpers';

export const getEmailByOobcode = async (oobCode: string) => {
  const auth = await getAuthentication();

  return verifyPasswordResetCode(auth, oobCode);
};
